var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10463 4.80011C5.10463 3.5801 5.11638 2.49647 5.10072 1.41097C5.08897 0.598245 5.45499 0.0844545 6.31815 0.00598479C7.0952 -0.0650117 7.60997 0.501091 7.62563 1.4147C7.64324 2.49833 7.62954 3.58383 7.62954 4.80011C8.83132 4.80011 9.95872 4.79451 11.0861 4.80198C12.1254 4.80945 12.7381 5.26159 12.7342 5.99771C12.7303 6.73383 12.1235 7.17476 11.0763 7.18223C9.97243 7.1897 8.86851 7.1841 7.62954 7.1841C7.62954 8.29762 7.63541 9.34389 7.62758 10.3901C7.61976 11.4252 7.20481 11.9633 6.40819 11.9876C5.56851 12.0137 5.11246 11.4551 5.10659 10.3827C5.10072 9.3607 5.10463 8.34059 5.10463 7.1841C3.90089 7.1841 2.77349 7.1897 1.64609 7.18223C0.59698 7.17476 -0.00195251 6.7357 4.78232e-06 5.99211C0.00391937 5.24664 0.598938 4.81132 1.65196 4.80385C2.75588 4.79451 3.85979 4.80011 5.10463 4.80011Z",
    fill: "#20ABAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInc);
export default __webpack_public_path__ + "static/media/ic_inc.db65a75261ca2576f7fc42bf86db06d9.svg";
export { ForwardRef as ReactComponent };